import './common.scss';
/**
 * Blocks Frontend Scripts
 */
import './blocks/container/front';
